import { Dropdown, Grid, Tabs, TabsProps } from 'antd';
import './CustomTabs.scss';
import { MoreOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;

interface CustomTabsProps extends TabsProps {
  className?: string;
}

const CustomTabs = (props: CustomTabsProps) => {
  const { className, tabBarGutter, items = [], activeKey, onChange, defaultActiveKey, ...rest } = props;
  const screens = useBreakpoint();
  
  // mobile
  const isMobileKebab = screens.xs && className?.includes('responsive-kebab-tabs');
  const validItems = items.filter(Boolean) as any[];
  const currentActiveKey = activeKey || defaultActiveKey || validItems[0]?.key;

  if (isMobileKebab && validItems.length > 2) {
    const activeIndex = validItems.findIndex(item => item.key === currentActiveKey);
    
    let visibleTabs = [];
    let hiddenTabs = [];

    if (activeIndex <= 0) {
      visibleTabs = validItems.slice(0, 2);
      hiddenTabs = validItems.slice(2);
    } else {
      visibleTabs = [validItems[0], validItems[activeIndex]];
      hiddenTabs = validItems.filter((_, idx) => idx !== 0 && idx !== activeIndex);
    }

    const menuItems = hiddenTabs.map(item => ({
      key: item.key,
      label: item.label,
    }));

    const processedItems = [
      ...visibleTabs,
      {
        key: 'more-dropdown-kebab',
        label: (
          <Dropdown
            menu={{
              items: menuItems,
              onClick: ({ key }) => onChange?.(key),
            }}
            trigger={['click']}
            placement="bottomRight"
          >
            <div className="flex items-center justify-center w-full h-full">
              <MoreOutlined className="text-[18px] !m-0" />
            </div>
          </Dropdown>
        ),
        children: validItems.find(item => item.key === currentActiveKey)?.children,
      }
    ];

    return (
      <Tabs
        {...rest}
        items={processedItems}
        activeKey={currentActiveKey === visibleTabs[0].key ? currentActiveKey : visibleTabs[1]?.key}
        onChange={(key) => {
          if (key !== 'more-dropdown-kebab') onChange?.(key);
        }}
        rootClassName="custom-tabs responsive-kebab-active"
        className={className}
        tabBarGutter={tabBarGutter ?? 12}
        tabPosition="top"
        destroyInactiveTabPane
      />
    );
  }

  return (
    <Tabs
      {...rest}
      items={items}
      activeKey={activeKey}
      onChange={onChange}
      defaultActiveKey={defaultActiveKey}
      rootClassName="custom-tabs"
      className={className}
      tabBarGutter={tabBarGutter ?? 12}
      tabPosition="top"
      destroyInactiveTabPane
    />
  );
};

export default CustomTabs;